import { render, staticRenderFns } from "./AxMealManualDialog.vue?vue&type=template&id=512ec50c&scoped=true"
import script from "./AxMealManualDialog.vue?vue&type=script&lang=ts"
export * from "./AxMealManualDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxMealManualDialog.vue?vue&type=style&index=0&id=512ec50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ec50c",
  null
  
)

export default component.exports